import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MainLayout } from "./shared/layouts/main-layout/main-layout";
import { ToastContainerComponent } from './shared/components/ui/toast/toast.component';
import { ThemeService } from './core/services';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MainLayout, ToastContainerComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('mockingbird-banking');
  private readonly theme = inject(ThemeService);
}
